import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Warning = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.warning.dark,
  margin: theme.spacing(-2, 0, 2),
}));
